import { SalesRole } from './roles';

/** The `data.page` value each page's route carries. */
export const PAGE_KEYS = [
  'order-entry',
  'edit-profile',
  'create-invoice',
  'sales-dashboard',
  'view-invoice-sales',
  'discount-page',
  'codes',
  'users-discount-code',
  'request-code',
  'users-enrollment',
  'affiliates',
  'edit-affiliate',
  'student-lookup',
  'corporates',
  'add-corporate-account',
  'corp-account-sites',
  'corporate-sites',
  'widget-details',
  'view-invoice-corporate',
  'archive',
] as const;

export type PageKey = (typeof PAGE_KEYS)[number];

/** Pages an MLG rep may open; every other page shows the no-access state. */
const MLG_PAGES: ReadonlySet<PageKey> = new Set<PageKey>([
  'order-entry',
  'edit-profile',
  'sales-dashboard',
  'create-invoice',
  'view-invoice-sales',
  'corporates',
]);

/** One check for every route: no per-role branches elsewhere. */
export function canAccess(role: SalesRole, page: PageKey): boolean {
  return role === 'SALES_REP' || MLG_PAGES.has(page);
}

export function isPageKey(value: unknown): value is PageKey {
  return typeof value === 'string' && (PAGE_KEYS as readonly string[]).includes(value);
}
